// Libraries
import styled from 'styled-components'

// Components
import { Aligner, Icon, InputText } from 'heeds-ds'

type Props = {
  editMode?: boolean
}

export const GridInputs = styled.div<Props>`
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, 1fr);

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    gap: 12px;
  }
`

export const HiddenButton = styled.button.attrs(() => ({
  type: 'button',
}))`
  background: none;
  border: none;
  cursor: pointer;
  margin: 0;
  padding: 0;
`

export const Container = styled(Aligner).attrs(() => ({
  flex: 'column',
  gap: '16px',
  padding: '8px',
}))<Props>`
  border-radius: 6px;
  :hover {
    background: ${({ theme, editMode }) =>
      editMode && theme.colors.surface.hovered};
  }
`

export const DeleteIcon = styled(Icon).attrs((props) => ({
  color: props.theme.colors.text.critical,
  iconName: 'delete',
  size: 20,
}))``

export const Header = styled(Aligner).attrs(() => ({
  align: 'center',
  gap: '16px',
  margin: '0',
}))``

export const InputNumber = styled(InputText).attrs(() => ({
  margin: '0',
  scale: 'small',
}))``

export const SwapIcon = styled(Icon).attrs((props) => ({
  color: props.theme.colors.icon.subdued,
  iconName: 'swapVert',
  size: 24,
}))``
